type Diagnostic = { id: string; error?: string; platforms?: { platform: string; error?: string | null }[] };
export function searchFailures(sources: Diagnostic[]) {
  return sources.flatMap(source => {
    const failures = (Array.isArray(source.platforms) ? source.platforms : []).filter(item => item.error).map(item => ({ id: `${source.id}:${item.platform}`, error: item.error || '' }));
    return failures.length ? failures : source.error ? [{ id: source.id, error: source.error }] : [];
  });
}
export function searchDiagnosticLabel(id: string) {
  const [source, platform] = id.split(':');
  const name = ({ yuxi: '屿溪', yuningxi: '玉宁熙', webdav: 'WebDAV' } as Record<string, string>)[source] || source;
  return platform ? `${name} · ${platform === 'tx' ? 'QQ音乐' : platform === 'wy' ? '网易云音乐' : platform}` : name;
}
